import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Label from './Label';
import ExpiryPill from './ExpiryPill';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginTop: 4,
  },
}));

const TitleContainer = ({ symbol = '', label = '' }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.root} TitleContainer`}>
      <Label label={label} />
      <ExpiryPill symbol={symbol} />
    </div>
  );
};

export default TitleContainer;
